<footer class="bg-secondary/50 border-t border-border">
  <div class="container mx-auto px-4 py-16">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div class="space-y-6">
        <a routerLink="/home" class="flex items-center gap-3">
          <img src="assets/landing-thi/logo.png" alt="THI Invoices" class="h-10 w-auto" />
        </a>
        <p class="text-muted-foreground text-sm leading-relaxed">
          {{ t.footer.description }}
        </p>
      </div>

      <div>
        <h4 class="text-foreground font-semibold mb-6">{{ t.footer.pages }}</h4>
        <ul class="space-y-3">
          <li>
            <a routerLink="/home" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.nav.home }}</a>
          </li>
          <li>
            <a routerLink="/pricing" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.nav.pricing }}</a>
          </li>
          <li>
            <a routerLink="/articles" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.nav.resources }}</a>
          </li>
          <li>
            <a routerLink="/support" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.nav.contact }}</a>
          </li>
          <li>
            <a routerLink="/about" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.nav.about }}</a>
          </li>
        </ul>
      </div>

      <div>
        <h4 class="text-foreground font-semibold mb-6">{{ t.footer.legal }}</h4>
        <ul class="space-y-3">
          <li>
            <a routerLink="/privacy-policy" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.footer.privacy }}</a>
          </li>
          <li>
            <a routerLink="/terms-of-service" class="text-muted-foreground hover:text-primary text-sm transition-colors">{{ t.footer.terms }}</a>
          </li>
        </ul>
      </div>

      <div>
        <h4 class="text-foreground font-semibold mb-6">{{ t.footer.contact }}</h4>
        <ul class="space-y-4">
          <li>
            <a
              href="mailto:info@thinvoices.com"
              class="flex items-center gap-3 text-muted-foreground hover:text-primary text-sm transition-colors"
            >
              <i class="fa fa-envelope w-4 flex-shrink-0"></i>
              info@thinvoices.com
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="mt-16 pt-8 border-t border-border">
      <p class="text-center text-muted-foreground text-sm">
        © {{ year }} THI Invoices. {{ t.footer.rights }}.
      </p>
    </div>
  </div>
</footer>
